import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { IIceEntity } from 'projects/icemedx-lib/src/models/core/IceEntity';

import { AppService } from '../app.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { PatientService } from 'projects/icemedx-lib/src/services/patient/patient.service';

import {
  IcecontrolSettings,
  iceColumnDefinition,
} from 'projects/icemedx-lib/src/components/models/icesettings';

import { PhrBaseListView } from '../phrbaselistview.component';
import { userTypes } from 'projects/icemedx-lib/src/login/login.config';
import { MessageService } from 'projects/icemedx-lib/src/services/message/message.service';

@Component({
  selector: 'app-phrproblems',
  templateUrl: './phrproblems.component.html',
  styleUrls: ['./phrproblems.component.scss'],
  providers: [AppService, IceNavService]
})
export class PhrproblemsComponent extends PhrBaseListView implements OnInit {

  constructor(appSvc: AppService, loginSvc: LoginService, messageSvc: MessageService, navSvc: IceNavService, ptSvc: PatientService, router: Router) {
    super(appSvc, loginSvc, navSvc, ptSvc, router);

    let feaAccess = this.getPermission(userTypes.USER_FEATURES.ufDiagnosis).default_access;
    this.nameOfView = "Problems";
    appSvc.defaultMenus();
    appSvc.addBreadcrumb(this.nameOfView, {}, true, "");

    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      setTimeout(function () {
        messageSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      });
    } else {
      this.dataViewSettings = this.viewSetup([], userTypes.USER_FEATURES.ufDiagnosis);

      ptSvc.getProblems(appSvc.getCurrentAccountType() == IceTypes.ACCOUNT_TYPE.actPatient ? appSvc.getCurrentAccount() : appSvc.getCurrentPatient()).subscribe(
        data => {
          this.refreshTableData(data);
        },
        error => {
        });
    }
  }

  ngOnInit() {
    this.getAppService().refreshMenus();
  }

  onGetColumnDefinition(): iceColumnDefinition[] {
    return [
      new iceColumnDefinition("title", "Problem or Diagnosis", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("diagnosis_key", "diagnosis_key", true),
    ];
  }

  onGetData(originalData: IIceEntity[]): any[] {
    return originalData;
  }
}
